export const titleColor = '#ccc'
